import React, { Suspense, Fragment, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import LayoutOne from '../../layouts/LayoutOne';
import { connect } from 'react-redux';
import HeroSliderOne from '../../wrappers/hero-slider/HeroSliderOne';
import FeatureIcon from '../../wrappers/feature-icon/FeatureIcon';
import TabProduct from '../../wrappers/product/TabProduct';
import FeaturedProducts from '../../wrappers/product/FeaturedProducts';
import BlogFeatured from '../../wrappers/blog-featured/BlogFeatured';
import PromotionalProductCategories from '../../wrappers/promotional-product/Promotional-product-categories';
import { AuthContext } from '../../common/Auth';
import BannerOne from '../../wrappers/banner/BannerOne';
import Newsletter from '../../wrappers/newsletter/Newsletter';
import SectionTitleWithText from '../../components/section-title/SectionTitleWithText';
import CountDownTwo from '../../wrappers/countdown/CountDownTwo';
import VideoPopup from '../../components/video-popup/VideoPopup';
import BrandLogoSliderThree from '../../wrappers/brand-logo/BrandLogoSliderThree';
import TestimonialTwo from '../../wrappers/testimonial/TestimonialTwo';
import ProductSlider from '../../wrappers/product/ProductSlider';
import ImageSliderOne from '../../wrappers/image-slider/ImageSliderOne';
import CategoryFourSlider from '../../wrappers/category/CategoryFourSlider';
import MetaTag from '../../helpers/MetaTag';
import Loader from '../../common/Loader';
import TextBox from '../../wrappers/text-box/textBox';
import TextBox2 from '../../wrappers/text-box2/TextBox2';
import TextBox3 from '../../wrappers/text-box3/TextBox3';

const Spring = ({ user, children, hideFooter })=>{
    const { actionGridList, themeSettingsData, loading } = useContext(AuthContext);
    const [bannerLoaded, setBannerLoaded] = useState(false)
    const listenerBannerLoaded = (event)=>{
        setBannerLoaded(event)
    }
    const getComponent = (data, index, totalDataCount)=>{
        if ( data.name === 'bannerSlider' ) {
            return <HeroSliderOne key={ index } setLoaded={ listenerBannerLoaded }/>;
        } else if ( data.name === 'featureIcon' ) {
            if ( actionGridList && actionGridList.length ) {
                return (
                    <FeatureIcon key={ index } spaceTopClass="mt-100" spaceBottomClass="pb-60"
                                 actionGridList={ actionGridList }/>
                );
            }
        } else if ( data.name === 'featuredProducts' ) {
            return <FeaturedProducts key={ index } spaceTopClass="mt-100" category="fashion"/>;
        } else if ( data.name === 'taggedProducts' ) {
            return <TabProduct key={ index } spaceTopClass="mt-100" category="fashion"/>;
        } else if ( data.name === 'blogs' ) {
            return <BlogFeatured key={ index } spaceBottomClass="pb-55"/>;
        } else if ( data.name === 'promotionalproduct' ) {
            return <PromotionalProductCategories/>;
        } else if ( data.name === 'categoriesSection' ) {
            return <BannerOne/>;
        } else if ( data.name === 'textBox1' ) {
            return <TextBox spaceTopClass="mt-95"/>;
        } else if ( data.name === 'textBox2' ) {
            return <TextBox2 spaceTopClass="mt-95"/>;
        } else if ( data.name === 'textBox3' ) {
            return <TextBox3 spaceTopClass="mt-95"/>;
        } else if ( data.name === 'whoWeare' ) {
            return <SectionTitleWithText spaceTopClass="mt-95"/>;
        } else if ( data.name === 'imageSlider' ) {
            return <ImageSliderOne key={ index }/>;
        } else if ( data.name === 'countDown' ) {
            return <CountDownTwo key={ index }/>;
        } else if ( data.name === 'videoPopup' ) {
            return <VideoPopup key={ index } spaceBottomClass="mb-50" spaceTopClass="mt-50"/>;
        } else if ( data.name === 'brandlogoSlider' ) {
            return <BrandLogoSliderThree key={ index } spaceTopClass="mt-50" spaceBottomClass="pb-95"/>;
        } else if ( data.name === 'testimonial' ) {
            return <TestimonialTwo key={ index }/>;
        } else if ( data.name === 'productSlider' ) {
            return <ProductSlider category="medical"/>;
        } else if ( data.name === 'categoriesSlider' ) {
            return <CategoryFourSlider key={ index } spaceTopClass="pt-100" spaceBottomClass="pb-95"/>;
        } else if ( index === totalDataCount ) {
            return (
                <>
                    <HeroSliderOne/>
                    { actionGridList && actionGridList.length && (
                        <FeatureIcon spaceTopClass="pt-100" spaceBottomClass="pb-60" actionGridList={ actionGridList }/>
                    ) }
                    <TabProduct spaceBottomClass="pb-60" category="fashion"/>
                    <FeaturedProducts spaceTopClass="mt-100" category="fashion"/>
                    <PromotionalProductCategories/>
                    <BlogFeatured spaceBottomClass="pb-55"/>
                </>
            )
        }
        return '';
    }

    function subChild() {
        let section_sequence = []
        if ( themeSettingsData && themeSettingsData.length > 0 ) {
            return themeSettingsData.map((i)=>{
                if ( i.settingsName === 'themeSections' ) {
                    section_sequence = (i.values[0]['spring']);
                    if ( section_sequence.length > 0 ) {
                        return section_sequence.filter(x=>x.isEnabled).map((data, index)=>{
                            return index === 0 ?
                                <Suspense fallback={ <Loader/> }>
                                    { getComponent(data, index, section_sequence.length) }
                                </Suspense> : (bannerLoaded ? <Suspense fallback={ <Loader/> }>
                                    { getComponent(data, index, section_sequence.length) }
                                </Suspense> : <>{ !bannerLoaded && getComponent(data, index, section_sequence.length) }</>)
                        })
                    } else {
                        return (
                            <Suspense
                                fallback={ <Loader/> }
                            >
                                <HeroSliderOne/>
                                { actionGridList && actionGridList.length && (
                                    <FeatureIcon spaceTopClass="pt-100" spaceBottomClass="pb-60"
                                                 actionGridList={ actionGridList }/>
                                ) }
                                <TabProduct spaceBottomClass="pb-60" category="fashion"/>
                                <FeaturedProducts spaceTopClass="mt-100" category="fashion"/>
                                <PromotionalProductCategories/>
                                <BlogFeatured spaceBottomClass="pb-55"/>
                            </Suspense>)
                    }
                }
            })
        }
    }

    function LoadComponent() {

        let section_sequence = []
        if ( themeSettingsData && themeSettingsData.length > 0 ) {
            themeSettingsData.map((i)=>{
                if ( i.settingsName === 'themeSections' ) {
                    section_sequence = (i.values[0]['spring']);
                }
            });
        }
        return (
            <Suspense fallback={ <Loader/> }>
                <LayoutOne
                    headerContainerClass="container-fluid"
                    headerPaddingClass="header-padding-1"
                    headerTop="visible"
                    isFooterEnabled={
                        !hideFooter &&
                        (section_sequence.length > 0 ? section_sequence.filter((data)=>data.name === 'footer')[0].isEnabled : true)
                    }
                >
                    { children ? (
                        children
                    ) : (
                        <Suspense fallback={ <Loader/> }>
                            { subChild() }
                        </Suspense>
                    ) }
                </LayoutOne>
            </Suspense>
        );
    }

    return (
        <Fragment>
            <MetaTag/>
            { LoadComponent() }
        </Fragment>
    );
};
Spring.propTypes = {
    location: PropTypes.object,
};
const mapStateToProps = (state)=>{
    return {
        user: state.userData.user,
    };
};

export default connect(mapStateToProps)(Spring);
